import { render, staticRenderFns } from "./AddNameExpenses.vue?vue&type=template&id=407dae51&scoped=true"
import script from "./AddNameExpenses.vue?vue&type=script&lang=js"
export * from "./AddNameExpenses.vue?vue&type=script&lang=js"
import style0 from "./AddNameExpenses.vue?vue&type=style&index=0&id=407dae51&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407dae51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407dae51')) {
      api.createRecord('407dae51', component.options)
    } else {
      api.reload('407dae51', component.options)
    }
    module.hot.accept("./AddNameExpenses.vue?vue&type=template&id=407dae51&scoped=true", function () {
      api.rerender('407dae51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/employeeSalary/employeeSalarySearchDialog/AddNameExpenses.vue"
export default component.exports